import { logger } from 'packages/logger';

function isSpaModule(module, initData) {
    const { isSinglePageApp } = initData;
    switch (module) {
        case 'start-page':
        case 'brand':
        case 'brand-list':
        case 'category-list':
        case 'endless-recommendation':
        case 'favourite-sellers':
        case 'landing':
        case 'report-item':
        case 'profile':
        case 'verify-bankid':
        case 'tradera-shop':
        case 'category':
        case 'custom-results':
        case 'search-results':
            return true;

        default:
            return isSinglePageApp;
    }
}

async function loadSpaModule(initData) {
    const module = await import(
        /* webpackChunkName: "tradera" */ '../../../../frontend/apps/tradera/'
    );
    return module.default(initData);
}

async function loadModule(module) {
    switch (module) {
        // Fallback modules for when SPA is toggled off
        // TODO: Remove when fully incorporated in SPA
        case 'start-page':
        case 'brand':
        case 'brand-list':
        case 'category-list':
        case 'landing':
        case 'order-checkout':
        case 'verify-bankid':
        case 'profile':
        case 'cart':
        case 'upi':
        case 'inr':
        case 'cause':
        case 'causes':
        case 'causes-info':
            return await import(
                /* webpackChunkName: "tradera" */ '../../../../frontend/apps/tradera/'
            );

        // Non-SPA modules
        case 'basic':
            return await import(
                /* webpackChunkName: "basic" */ '../app/pages/basic'
            );
        case 'bidding':
            return await import(
                /* webpackChunkName: "bidding" */ '../app/pages/bidding'
            );
        case 'checkout2':
            return await import(
                /* webpackChunkName: "checkout2" */ '../app/pages/checkout2'
            );
        case 'detailed-search':
            return await import(
                /* webpackChunkName: "detailed-search" */ '../app/pages/detailed-search'
            );
        case 'image-search':
            return await import(
                /* webpackChunkName: "image-search" */ 'tradera-apps/image-search'
            );
        case 'messages':
            return await import(
                /* webpackChunkName: "messages" */ '../app/pages/messages'
            );
        case 'messaging':
            return await import(
                /* webpackChunkName: "messaging-iframe" */ '../app/pages/messaging'
            );
        default:
            return await import(
                /* webpackChunkName: "basic" */ '../app/pages/basic'
            );
    }
}

function runModule(module, initData = {}) {
    if (!module.default) {
        console.error(`Cannot run module "${module}" without exported default`);
    }
    return module.default(initData);
}

const handleModuleError = error => logger(error);

export { isSpaModule, loadSpaModule, loadModule, runModule, handleModuleError };
